var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"margin-right":"20px"},attrs:{"flat":"","outlined":"","width":"300px"},on:{"click":_vm.goToSubmissions}},[_c('v-card-text',{class:this.thekey == '' ? 'zero' : 'grade'},[_vm._v(" "+_vm._s(this.grade)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }